import { t } from 'i18next';
interface HelpContent {
  [index: string]: {
    title: string;
    message: string;
    link: string;
    linkText: string;
  };
}

export default function InlineHelpContent(helpKey: string) {
  const InlineHelpMessage = t('Overview and support:');
  const INLINE_HELP_CONTENT: HelpContent = {
    // field types

    // You can add other control types here and the link will appear automatically on the template
    // editor, just set the key name as "field_type_<control_type_name>" with any spaces in the name
    // replaced by underscores. See controlTypesText.ts for the list of names.
    field_type_geolocation: {
      title: 'Geolocation',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404045202457-Field-Types-Geolocation-controls',
      linkText: t('Geolocation Controls'),
    },

    field_type_diagram: {
      title: 'Diagram',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404053399065-Field-Types-Diagram-controls',
      linkText: t('Diagram Controls'),
    },

    field_type_attachment: {
      title: 'Attachment',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404044399001-Attach-Forms-Actions-Images-and-Files-Attachment-controls',
      linkText: t('Attachment Controls'),
    },

    // REGISTERS
    forms_register: {
      title: 'Forms',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404141876377-Records-and-Registers-Forms',
      linkText: t('Introduction to the Form register'),
    },
    // Should actually be an article called "Records and Registers: Memos" old link was https://support.apemobile.com/en/articles/1431229-records-and-registers-memos
    memos_register: {
      title: 'Memos',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404224717081-Where-have-Memos-and-Punch-Lists-gone-',
      linkText: t('Introduction to the Memo register'),
    },
    actions_register: {
      title: 'Actions',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404254665625-Video-Tutorial-Managing-Records-and-Registers-Actions-and-Punch-Lists',
      linkText: t('Introduction to the Action register'),
    },
    punch_lists_register: {
      title: 'Punch Lists',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404102610201-Using-Damstra-Forms-Punch-lists',
      linkText: t('Introduction to the Punch List register'),
    },
    drawings_register: {
      title: 'Drawings & Docs',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404118429081-Using-Damstra-Forms-Records-and-Registers-Drawings-Docs',
      linkText: t('Introduction to the Drawings and Docs register'),
    },

    // TEMPLATES
    templates: {
      title: 'Templates',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403156362009-Templates-Forms',
      linkText: t('Managing Templates'),
    },
    // TEMPLATE EDITOR
    template_editor: {
      title: 'Template Editor',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403156362009-Templates-Forms',
      linkText: t('Template Creation Overview'),
    },
    template_editor_approvals: {
      title: 'Approval Section',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404054016025-Using-approvals-in-forms',
      linkText: t('Approval Section'),
    },
    formula: {
      title: 'Formula',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404039162009-Using-Formulas-Formulas-in-forms-Introduction',
      linkText: t('Using Formulas in Forms'),
    },

    // MAIN SITE
    users: {
      title: 'Users',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404172525081-Organisation-Administration-Managing-Users',
      linkText: t('Managing Users'),
    },
    projects: {
      title: 'Projects',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404104310809-Project-Administration-Managing-Projects',
      linkText: t('Managing Projects'),
    },
    project_lists: {
      title: 'Project Lists',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404082812441-Project-Administration-Project-List-items',
      linkText: t('Project List Items'),
    },
    project_list_types: {
      title: 'Project List Types',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404164023961-Organisation-Administration-Managing-Project-List-Types',
      linkText: t('Project List Types'),
    },
    project_members: {
      title: 'Project Members',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404130186137-Project-Administration-Project-members',
      linkText: t('Managing Project Members'),
    },
    organisation_lists: {
      title: 'Organization Lists',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404212251545-Organisation-Administration-Managing-Organization-Lists',
      linkText: t('Managing Org Lists'),
    },
    organisation_settings: {
      title: 'Organization Settings',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404224718105-Organisation-Administration-Organisation-Settings',
      linkText: t('Org Settings Overview'),
    },
    companies: {
      title: 'Companies',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404107853849-Organisation-Administration-Using-the-Companies-List',
      linkText: t('Managing Companies'),
    },
    drawings_import: {
      title: 'Import Drawings & Docs',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404008931609-Exports-and-Imports-Importing-Drawings-and-Documents-in-Bulk',
      linkText: t('Importing Drawings and Documents'),
    },
    exports: {
      title: 'Exports',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404055000857-Exports-and-Imports-Exports-Overview',
      linkText: t('Exports'),
    },
    default_templates: {
      title: 'Default Templates',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404022154137-Adding-Form-Templates-to-Projects',
      linkText: t('Adding templates to your Projects'),
    },
    custom_exports: {
      title: 'Custom Exports',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404024969497-Exports-and-Imports-Custom-Exports',
      linkText: t('Custom Export Help'),
    },
    wbs_items: {
      title: 'WBS Items',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404112801561-Project-Administration-WBS-Items',
      linkText: t('Managing WBS Items'),
    },
    sequence_numbers: {
      title: 'Sequence Numbers',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404111379097-Project-Administration-Sequence-Numbers',
      linkText: t('Sequence Numbers'),
    },
    properties: {
      title: 'Properties',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404048690201-Project-Administration-Project-Properties',
      linkText: t('Project Properties Overview'),
    },
    change_log: {
      title: 'Change Log',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404048690201-Project-Administration-Project-Properties',
      linkText: t('Change Log'),
    },
    reporting_project: {
      title: 'Reporting Project',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404064947353-Project-Administration-Reporting-Projects',
      linkText: t('What is a Reporting Project?'),
    },
    new_user: {
      title: 'Creating a new user',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404172525081-Organisation-Administration-Managing-Users',
      linkText: t('Creating a new user'),
    },
    edit_user: {
      title: 'Editing user details',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404172525081-Organisation-Administration-Managing-Users',
      linkText: t('Editing user details'),
    },
    identity_providers: {
      title: 'Identity Providers',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8405134241049-Ways-to-sign-in-Setting-up-SSO',
      linkText: t('Ways to sign in - Setting up SSO'),
    },
    approver_types: {
      title: 'Approver Types',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404137438233-Organisation-Administration-Approval-sections',
      linkText: t('Organisation Administration - Approval sections'),
    },

    //ALERTS
    alerts: {
      title: 'Alerts',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8405101957785-Insights-Getting-email-alerts',
      linkText: t('Managing Alerts'),
    },
    alerts_email_params: {
      title: 'Alerts',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8405088623513-Insights-Alert-email-parameters',
      linkText: t('Alert Email Parameters'),
    },

    // METRICS (formerly PROGRESS POINTS)
    metrics: {
      title: 'Metrics',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8405074721049-Insights-Setting-up-your-metrics',
      linkText: t('Managing Metrics'),
    },

    // GENERAL INTEGRATION
    integration_subdomain: {
      title: 'Choosing a Subdomain',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404047962649-Starting-a-trial-Choosing-a-subdomain',
      linkText: t('Choosing a Subdomain'),
    },

    // PROCORE INTEGRATION
    procore_connector: {
      title: 'Procore Integration Overview',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403144687385-API-and-Integrations',
      linkText: t('Procore Integration Overview'),
    },
    procore_trial_projects: {
      title: 'Selecting Projects',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403144687385-API-and-Integrations',
      linkText: t('Selecting Projects'),
    },
    procore_trial_users: {
      title: 'Selecting Users',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403144687385-API-and-Integrations',
      linkText: t('Selecting Users'),
    },
    procore_setup: {
      title: 'Procore Integration Setup',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403144687385-API-and-Integrations',
      linkText: t('Procore Integration Setup'),
    },
    procore_projects: {
      title: 'Adding or Linking Projects from Procore',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403144687385-API-and-Integrations',
      linkText: t('Adding or Linking Projects from Procore'),
    },
    procore_users: {
      title: 'Adding or Linking Users from Procore',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403144687385-API-and-Integrations',
      linkText: t('Adding or Linking Users from Procore'),
    },
    procore_activation: {
      title: 'Activating your Procore Integration',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/sections/8403144687385-API-and-Integrations',
      linkText: t('Activating your Procore Integration'),
    },

    // BIM 360 INTEGRATION
    bim360_connector: {
      title: 'BIM 360 Integration Overview',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8405087864473-Get-connected-BIM-360-integration',
      linkText: t('BIM 360 Integration Overview'),
    },
    bim360_trial_projects: {
      title: 'Selecting Projects',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404026258457-Starting-a-trial-Connecting-a-BIM-360-Project',
      linkText: t('Selecting a project'),
    },
    bim360_trial_users: {
      title: 'Selecting Users',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404077081241-Starting-a-trial-Adding-BIM-360-users-to-Damstra-Forms',
      linkText: t('Selecting Users'),
    },
    bim360_setup: {
      title: 'BIM 360 Integration Setup',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404117803417-BIM-360-Integration-Setting-up-the-BIM-360-Integration',
      linkText: t('BIM 360 Integration Setup'),
    },
    bim360_activation: {
      title: 'Activating and Configuring your BIM 360 Integration',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404070478745-BIM-360-Integration-Activating-Your-BIM-360-Integration',
      linkText: t('Activating and Configuring your BIM 360 Integration'),
    },
    bim360_folder: {
      title: 'Specifying your BIM 360 Project Files Subfolder',
      message: InlineHelpMessage,
      link:
        'https://damstra.zendesk.com/hc/en-us/articles/8404025949977-BIM-360-Integration-Specifying-your-BIM-360-Project-Files-Subfolder',
      linkText: t('Specifying your BIM 360 Project Files Subfolder'),
    },

    // BILLING
    billing: {
      title: '',
      message: '',
      link: '',
      linkText: '',
    },
    billing_users: {
      title: '',
      message: '',
      link: '',
      linkText: t('Total number of user licenses available'),
    },
    billing_addons: {
      title: '',
      message: '',
      link: '',
      linkText: t('Total number of Super Power addons'),
    },
    billing_external: {
      title: '',
      message: '',
      link: '',
      linkText: t('Total number of External User licenses available'),
    },
  };
  return INLINE_HELP_CONTENT[helpKey];
}
